import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M677.647059,283.848471 L1920,283.848471 L1920,57.9661176 L677.647059,57.9661176 L677.647059,283.848471 Z M0,57.9661176 L0,1639.25553 L348.649412,1639.25553 L348.649412,1861.41082 L790.588235,1526.31435 L348.649412,1190.992 L348.649412,1413.26024 L225.882353,1413.26024 L225.882353,57.9661176 L0,57.9661176 Z M677.647059,735.726118 L1920,735.726118 L1920,509.843765 L677.647059,509.843765 L677.647059,735.726118 Z M677.647059,1187.37788 L1920,1187.37788 L1920,961.495529 L677.647059,961.495529 L677.647059,1187.37788 Z M1694.11765,1639.25553 L1920,1639.25553 L1920,1413.26024 L1694.11765,1413.26024 L1694.11765,1639.25553 Z M1355.29412,1639.25553 L1581.28941,1639.25553 L1581.28941,1413.26024 L1355.29412,1413.26024 L1355.29412,1639.25553 Z M1016.47059,1639.25553 L1242.35294,1639.25553 L1242.35294,1413.26024 L1016.47059,1413.26024 L1016.47059,1639.25553 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveDownBottomSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveDownBottomSolid, _Component);

  var _super = _createSuper(IconMoveDownBottomSolid);

  function IconMoveDownBottomSolid() {
    _classCallCheck(this, IconMoveDownBottomSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveDownBottomSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveDownBottom",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveDownBottomSolid.displayName = "IconMoveDownBottomSolid";
  return IconMoveDownBottomSolid;
}(Component);

IconMoveDownBottomSolid.glyphName = 'move-down-bottom';
IconMoveDownBottomSolid.variant = 'Solid';
IconMoveDownBottomSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveDownBottomSolid;
export { IconMoveDownBottomSolid };